/**
 * @generated SignedSource<<96234ded8c8a37849ae17c60d8d67d56>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SlotAvailability = "ACCESSIBLE" | "ACCESSIBLE_BOOKING" | "AVAILABLE" | "AVAILABLE_AFTER_START" | "BLOCKED" | "BLOCKED_BY_BLOCK" | "BLOCKED_BY_BOOKING" | "BLOCKED_BY_EVENT" | "FREE" | "UNAVAILABLE";
import { FragmentRefs } from "relay-runtime";
export type useGetFullfillableSlots_booking$data = {
  readonly fullfillableSlots?: ReadonlyArray<{
    readonly availability: SlotAvailability;
    readonly course: {
      readonly name: string;
    };
    readonly id: string;
    readonly slotRates: ReadonlyArray<{
      readonly eighteenHolePrice: number | null | undefined;
      readonly nineHolePrice: number | null | undefined;
      readonly rate: {
        readonly name: string;
      };
    } | null | undefined> | null | undefined;
    readonly time: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "useGetFullfillableSlots_booking";
};
export type useGetFullfillableSlots_booking$key = {
  readonly " $data"?: useGetFullfillableSlots_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetFullfillableSlots_booking">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetFullfillableSlots_booking",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSlot",
          "kind": "LinkedField",
          "name": "fullfillableSlots",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "time",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "availability",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Course",
              "kind": "LinkedField",
              "name": "course",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": "slotRates",
              "args": [
                {
                  "kind": "Literal",
                  "name": "highestPrecedentOnly",
                  "value": true
                },
                {
                  "kind": "Literal",
                  "name": "type",
                  "value": "CUSTOMER"
                }
              ],
              "concreteType": "SlotRate",
              "kind": "LinkedField",
              "name": "playerRates",
              "plural": true,
              "selections": [
                {
                  "alias": "nineHolePrice",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "holeCount",
                      "value": "NINE"
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "totalGolfPrice",
                  "storageKey": "totalGolfPrice(holeCount:\"NINE\")"
                },
                {
                  "alias": "eighteenHolePrice",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "holeCount",
                      "value": "EIGHTEEN"
                    }
                  ],
                  "kind": "ScalarField",
                  "name": "totalGolfPrice",
                  "storageKey": "totalGolfPrice(holeCount:\"EIGHTEEN\")"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "rate",
                  "plural": false,
                  "selections": (v0/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": "playerRates(highestPrecedentOnly:true,type:\"CUSTOMER\")"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "StandardBooking",
      "abstractKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "aa07794b3fcd551701e03a37e8efd475";

export default node;
